import React from 'react'
import Box from '@material-ui/core/Box'
import Paper from '@material-ui/core/Paper'
import TabbedView from '../components/TabbedView'
import TagTypeList from '../tag-types/List'
import TagList from './List'

const TagsManagement = (props) => {
  return (
    <Box>
      <Paper>
        <TabbedView
          tabLabels={['Tag Types', 'Tags']}
          tabsProps={{ centered: false }}
          headerProps={{ style: { backgroundColor: 'white' } }}
        >
          <Box>
            <TagTypeList basePath="/tag-types" resource="tag-types" />
          </Box>
          <Box>
            <TagList basePath="/tags" resource="tags" />
          </Box>
        </TabbedView>
      </Paper>
    </Box>
  )
}

export default TagsManagement

